const routes = [{
  path: '/salary/commission',
  component: () => import('@/views/salary/commission'),
  name: 'salary-commission',
  meta: {
    title: '佣金查询'
  }
}, {
  path: '/salary',
  component: () => import('@/views/salary'),
  name: 'salary-home',
  meta: {
    title: '工资查询',
    desc: '（适用于兼业机构、合同制代理人等的工资查询）'
  }
}, {
  path: '/salary/task',
  component: () => import('@/views/insurance/import'),
  name: 'salary-task',
  meta: {
    title: '工资任务列表',
    desc: ''
  }
}, {
  path: '/salary/addition',
  component: () => import('@/views/salary/addition'),
  name: 'salary-addition',
  meta: {
    title: '加扣款管理',
    desc: ''
  }
}, {
  path: '/salary/attendance',
  component: () => import('@/views/salary/attendance'),
  name: 'salary-attendance',
  meta: {
    title: '考勤管理'
  }
}, {
  path: '/salary/attendance/detail',
  component: () => import('@/views/salary/attendanceDetail'),
  name: 'salary-attendance-detail',
  meta: {
    title: '考勤详情'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/human/salary.js